import { observer } from 'mobx-react';
import { useRef } from 'react';
import { GroupResource } from '../../../../../GroupsStore/Types';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import { Link } from '../../../../../Resource/Types';
import ModalDisplay from './ModalDisplay';
import OpenModalButton from './OpenModalButton';
import Reactions from './Reactions';
import { AddLicenseToGroupsStore } from './Store';

interface Props {
  links: ReadonlyArray<Link>;
  multicheckStore: MulticheckStore<GroupResource>;
}

function AddLicenseToGroups({ links, multicheckStore }: Props) {
  const licenseAllocationsStore = useRef(new AddLicenseToGroupsStore()).current;

  return (
    <>
      <OpenModalButton
        loading={licenseAllocationsStore.loading}
        links={links}
        multicheckStore={multicheckStore}
      />
      <ModalDisplay licenseAllocationsStore={licenseAllocationsStore} />
      <Reactions store={licenseAllocationsStore} fireImmediately />
    </>
  );
}

export default observer(AddLicenseToGroups);
